import type { FaireProductEntity } from "../../entity_types/product";

export const ramen_5: FaireProductEntity = {
  token: "ramen-5",
  type: "product",
  name: "Ramen Coin Purse",
  brandName: "Lily Posh",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/023687b8327ab37f2eb00099650239d32b9ab27a109f117ca4bbcbd06ba36415.png",
  priceDollars: 24,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/023687b8327ab37f2eb00099650239d32b9ab27a109f117ca4bbcbd06ba36415.png",
  weight: 0.1,
  dimensions: {
    width: 4,
    height: 3,
    depth: 1,
  },
  description: "Playful ramen-themed coin purse",
  categoryTokens: ["cat_accessories"],
  tags: ["ramen", "japanese-ramen", "accessory", "purse", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
